import React, { useState } from "react";

const faqData = [
  {
    id: "check1",
    question: "How do I open an account ?",
    content: (
      <>
        <p>
          <b>Physical Process</b>
        </p>
        <p>You can open your account in just a few easy steps:</p>
        <p className="my-0">1. Complete filling in your investor details .</p>
        <p className="my-0">
          2. Our relationship executive will personally connect with you to
          verify documents, collect KYC paperwork, and obtain signatures.
        </p>
        <p className="my-0">
          3. Once the KYC process is completed, your account will be activated
          within 3 working days.
        </p>
        <p className="my-0">
          4. You will receive an email confirmation as soon as your account is
          ready for trading.
        </p>
        <p>
          <b>Digital Process</b>
        </p>
        <p>You can open your account online in just a few simple steps:</p>
        <p className="my-0">
          1. Enter your basic information such as PAN, Aadhaar, bank details,
          and personal information through our secure digital onboarding portal.
        </p>
        <p className="my-0">
          2. Verify your identity instantly using Aadhaar-based OTP
          authentication and upload the required documents digitally.
        </p>
        <p className="my-0">
          3. Review your application form and complete the process with a secure
          e-signature.
        </p>
        <p className="mt-0">
          4. Once verification is successful, your trading and Demat account
          will be activated within 1–2 working days. You will receive an email
          and SMS confirmation when your account is ready for trading.
        </p>
      </>
    ),
  },
  {
    id: "check2",
    question: "How do I place a trade?",
    content: (
      <p>
        You can place a trade by logging in to the web online trading portal or
        the mobile app, or by contacting your designated dealer or relationship
        manager. Simply select the security, choose the order type (Market or
        Limit), specify the quantity and price (if applicable), and confirm your
        order. Once placed, the trade is executed based on prevailing market
        conditions, and you will receive real-time confirmation along with a
        contract note after execution.
      </p>
    ),
  },
  {
    id: "check3",
    question: "What are your commissions and fees?",
    content: (
      <p>
        Our commission and fee structure is transparent and competitive,
        designed to align with your trading activity and investment needs.
        Charges may vary based on the products and services availed and are
        communicated upfront to ensure complete clarity before you trade.
      </p>
    ),
  },
  {
    id: "check4",
    question: "How do you ensure the privacy and security of my account?",
    content: (
      <p>
        We ensure the privacy and security of your account through robust
        internal controls, advanced security systems, and strict adherence to
        regulatory and compliance standards. Client data is protected using
        secure access protocols, regular system monitoring, and confidentiality
        policies to safeguard information and transactions at all times.
      </p>
    ),
  },
  {
    id: "check5",
    question: "How does our firm manage risk and protect client capital?",
    content: (
      <p>
        Capital preservation is foundational to our approach. Every decision is
        guided by disciplined risk frameworks, continuous monitoring, and
        proactive oversight. We prioritise downside protection during volatility
        while selectively capturing high-conviction opportunities—ensuring
        resilience, stability, and long-term wealth compounding.
      </p>
    ),
  },
  {
    id: "check6",
    question: "Do we offer personalised portfolio strategies?",
    content: (
      <>
        <p>
          Every portfolio we design is distinctly bespoke—crafted around your
          financial aspirations, risk philosophy, and investment horizon. Our
          approach ensures precise alignment, adaptive strategy, and a
          disciplined path toward long-term wealth creation.
        </p>
        <p>
          Strategies are continuously refined to reflect evolving market
          dynamics and your changing priorities. This ensures your portfolio
          remains resilient, relevant, and positioned for sustained
          outperformance.
        </p>
      </>
    ),
  },
];

const FAQ = () => {
  const [openId, setOpenId] = useState(null);

  const toggle = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section id="faq-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center mb-4">
            <h3 data-aos="fade-up">Get Answers To Your Questions</h3>
          </div>
          <div className="col-lg-12">
            <div className="accordion-wrapper">
              {faqData.map((item, index) => {
                const isOpen = openId === item.id;
                return (
                  <div className="accordion" key={item.id}>
                    <button
                      id={`faq-button-${item.id}`}
                      className="accordion-label"
                      style={{
                        ...(index === 0 ? { borderTop: 0 } : {}),
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        textAlign: "left",
                      }}
                      onClick={() => toggle(item.id)}
                      aria-expanded={isOpen}
                      aria-controls={`faq-content-${item.id}`}
                    >
                      <span>{item.question}</span>
                      <span
                        className="accordion-icon"
                        aria-hidden="true"
                        style={{
                          transform: isOpen ? "rotate(90deg)" : "rotate(0deg)",
                          display: "inline-block",
                          transition: "transform 0.3s ease",
                          marginLeft: "10px",
                        }}
                      >
                        &#10095;
                      </span>
                    </button>
                    <div
                      id={`faq-content-${item.id}`}
                      role="region"
                      aria-labelledby={`faq-button-${item.id}`}
                      aria-hidden={!isOpen}
                      className="accordion-content"
                      style={{
                        maxHeight: isOpen ? "100vh" : "0",
                        padding: isOpen ? "5px 0px" : "0",
                        overflow: "hidden",
                        visibility: isOpen ? "visible" : "hidden",
                        transition: "all 0.3s ease",
                      }}
                    >
                      {item.content}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
